import * as preDiningComponents from 'reservations/preDining/components';
import { registerComponents } from 'reservations/preDining/helpers/website-components';

export const createRegistry = () => {
  registerComponents(preDiningComponents, 'preDining');
};
